import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as loginActions from 'modules/login';
import * as userActions from 'modules/user';

import * as common from 'libs/commonFunc';

class TimerSessionCheck extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.timer = setInterval(this.checkTime, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  checkTime = () => {
    const spendTime = common.nowEpoch().toFixed() - Number(sessionStorage.getItem('accessTime')).toFixed();
    const { sessionTimeout } = this.props;

    if (sessionTimeout < spendTime) {
      const { UserActions, LoginActions } = this.props;
      localStorage.removeItem('loginAdmin');
      localStorage.removeItem('loginUser');
      sessionStorage.removeItem('curUser');
      // 로그아웃 처리
      UserActions.logout();
      // 로그인 초기화
      LoginActions.setInitial();
    }
  };

  render() {
    return <div />;
  }
}

const mapStateToProps = state => ({
  sessionTimeout: state.user.get('sessionTimeout')
});

const mapDispatchToProps = dispatch => ({
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerSessionCheck);



// WEBPACK FOOTER //
// ./src/script/components/common/TimerSessionCheck.js